import { SET_STATE, RESET, SET_CLASSROOM_TEAMS_ENABLED, SET_TEAMS,SET_TEAM_NAME , DELETE_TEAM, SET_SELECTABLE_MEMBERS, ADD_TEAM_MEMBER, REMOVE_TEAM_MEMBER, MAKE_TEAM_CAPTAIN, REVOKE_TEAM_CAPTAIN, ADD_TEAM } from './actionTypes'

function initialState() {
    return {
      classroomChooseChallengeVisible : false,
      classroomTeamsPortalVisible : false,
      classroomTeamCreateVisible : false,
      classroomTeamManageVisible: false,
      classroomTeamsEnabled : null,
      teams : {},
      teamsSorted : [],
      teamMemberIndex : {},
      selectableMembers : {}
    }
}

export default function (state = initialState(), action) {

    switch (action.type) {

        case SET_STATE:

            const newState = action.newState
            
            for ( var key in newState ) {
                if ( newState.hasOwnProperty( key ) && state.hasOwnProperty( key ) ) {
                    state[key] = newState[key]
                } 
            }

            break

        case RESET : 

            state = initialState()
        
            break

        case SET_CLASSROOM_TEAMS_ENABLED:

            state.classroomTeamsEnabled = action.enabled

            break

        case SET_TEAMS:

            state.teams = Object.assign({}, action.teams )
            state.teamMemberIndex = Object.assign({}, state.teamMemberIndex, makeTeamMemberIndex( action.teams ))

            state.teamsSorted = sortTeams( { teams : state.teams } )


            break

        case ADD_TEAM:

            state.teams = Object.assign({}, state.teams, { [ action.team.teamId ] : action.team } )

            state.teamMemberIndex = Object.assign({}, state.teamMemberIndex, makeTeamMemberIndex( state.teams ))
            state.teamsSorted = sortTeams( { teams : state.teams } )

            break;
        case SET_TEAM_NAME:
            if ( state.teams.hasOwnProperty( action.team.teamId ) ) {
                state.teams[ action.team.teamId ].name = action.name
            } else {
                throw 'no such team here'
            }
            break
        case DELETE_TEAM:
            const teamId = action.team.teamId

            delete state.teams[ teamId ];

            state.teams = Object.assign({}, state.teams )
            state.teamMemberIndex = Object.assign({}, makeTeamMemberIndex( state.teams ))
            state.teamsSorted = sortTeams( { teams : state.teams } )

            break;

        case ADD_TEAM_MEMBER:
            state.teams[ action.team.teamId ].members[action.member.id]=action.member
            if ( state.selectableMembers[ action.member.id ] && state.selectableMembers[ action.member.id ].isOnline ) state.teams[ action.team.teamId ].onlineCount++

            state.teams[ action.team.teamId ].members = Object.assign( {}, state.teams[ action.team.teamId ].members)

            state.teamMemberIndex = Object.assign({}, makeTeamMemberIndex( state.teams ))

            break
        case REMOVE_TEAM_MEMBER:

            delete state.teams[ action.team.teamId ].members[action.member.id]
            if ( state.selectableMembers[ action.member.id ] && state.selectableMembers[ action.member.id ].isOnline ) state.teams[ action.team.teamId ].onlineCount--

            state.teams[ action.team.teamId ].members = Object.assign( {}, state.teams[ action.team.teamId ].members)

            state.teamMemberIndex = Object.assign({}, makeTeamMemberIndex( state.teams ))
            
            break
        case MAKE_TEAM_CAPTAIN:
            state.teams[ action.team.teamId ].members[action.member.id].captain = true
            state.teams[ action.team.teamId ].members = Object.assign( {}, state.teams[ action.team.teamId ].members)
            break;
        case REVOKE_TEAM_CAPTAIN:
            state.teams[ action.team.teamId ].members[action.member.id].captain = false
            state.teams[ action.team.teamId ].members = Object.assign( {}, state.teams[ action.team.teamId ].members)
            break;
        case SET_SELECTABLE_MEMBERS:

            state.selectableMembers = action.selectableMembers
            var sortable=[]
            for (let [ id, member ] of Object.entries( action.selectableMembers ) ) {
                sortable.push(member)
            }
            sortable.sort( (a,b) => ((a.profile.firstname + a.profile.lastname).toLowerCase() > ( b.profile.firstname + b.profile.lastname).toLowerCase() ? 1 : -1 ) )
            state.selectableMembersSorted=sortable

            break
            
        default:
    }

    return state;

}

function makeTeamMemberIndex( teams ) {
    var index = {}
    for (let [ teamId, team ] of Object.entries( teams ) ) {
        if ( team.members ) {
            for (let [ memberId, member ] of Object.entries( team.members ) ) {
                index[ memberId ] = team
            }
        }
    }
    return index
}

function sortTeams( options={} ) {
    var sortable=[]
    for (let [ id, team ] of Object.entries( options.teams ) ) {
        sortable.push( team )
    }

    console.log('test');


    if ( sortable.length ) sortable.sort( (a,b) => (( (a.name ).toLowerCase() > ( b.name ).toLowerCase()) || b.defaultTeam ? 1 : -1 ) )
    return sortable
}
